export default __webpack_public_path__ + "static/media/3_Sistema fidelizacion_1636x1341.8f2e6ad0.png";